// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__EmSgk","spinner":"loader_spinner__j0zfS","path":"loader_path__w9JGh","dash":"loader_dash__0wgiP","path1":"loader_path1__tmpCX"};